var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { IsBoolean, IsEmail, IsInt, Min } from "class-validator";
import { safeAssign } from "./safe-assign";
export class LoginThrottleStatusParams {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsEmail(),
    __metadata("design:type", String)
], LoginThrottleStatusParams.prototype, "email", void 0);
export class ResetLoginThrottleParams {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsEmail(),
    __metadata("design:type", String)
], ResetLoginThrottleParams.prototype, "email", void 0);
export class LoginThrottleStatusDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], LoginThrottleStatusDTO.prototype, "locked", void 0);
__decorate([
    Expose(),
    IsInt(),
    Min(0),
    __metadata("design:type", Number)
], LoginThrottleStatusDTO.prototype, "lockSecondsRemaining", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], LoginThrottleStatusDTO.prototype, "hasFailedAttempts", void 0);
//# sourceMappingURL=login-throttle.dto.js.map